import axios from "axios";

const getBaseURL = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  ) {
    return "http://localhost:4000/api";
  }
  return "https://chantal-api-ru6d.onrender.com/api";
};

const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});


// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (!config.headers) config.headers = {};

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      setTimeout(() => {
        // window.location.href = "/login";
      }, 3000);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// What the API sends when the stored token is missing, expired or tampered with
const SESSION_ERRORS = [
  "jwt expired",
  "jwt malformed",
  "invalid signature",
  "invalid token",
  "Access denied. No token provided.",
  "Unauthorized: No token provided",
];

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const message = error.response?.data?.error;
    // Only end the session if this request carried a token; visitors without one are left alone
    const sentToken = Boolean(error.config?.headers?.Authorization);

    if (sentToken && SESSION_ERRORS.includes(message)) {
      localStorage.removeItem("authToken");
      localStorage.removeItem("persist:root");

      try {
        const storeModule = await import("./state/store");
        const authModule = await import("./state/authSlice");

        const { store, persistor } = storeModule;
        const { logout } = authModule;

        // Reset Redux state
        store.dispatch(logout());

        // Purge redux-persist state
        await persistor.purge();

        // Forcefully remove persist:root from localStorage
        localStorage.removeItem("persist:root");

        // Optional: notify user
        // toast.error("Session expired. Redirecting to login...");
      } catch (err) {
        console.error("Error during logout and state purge:", err);
      }

      const inAdmin = window.location.pathname.startsWith("/admin");
      setTimeout(() => {
        window.location.href = inAdmin ? "/admin/login" : "/login";
      }, 2000);
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
